/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {linkCard} from '../api'

export const useMutationLinkCard = createReactQueryMutationHook('linkCard', linkCard)
